import { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import { connect } from "react-redux";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import CustomizedTextField from "../Input/CustomizedTextField";

class ManualSearchTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serialNumber: "",
            columns: [
                {
                    Header: "Historique de recherche",
                    Cell: ({ row }) => {
                        let currentHistoryLine = this.props.searchHistory[row.index];

                        if (!currentHistoryLine) return null;

                        return (
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                    <span>{currentHistoryLine.searchInput}</span>
                                </div>
                            </div>
                        );
                    },
                },
            ],
        };

        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleSerialNumberChange = this.handleSerialNumberChange.bind(this);
    }

    handleSearchClick(e) {
        e.preventDefault();

        if (this.state.serialNumber !== null) this.props.searchLiquidBottle(this.state.serialNumber);
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: () => {
                    this.props.searchLiquidBottle(row.row.original.searchInput);
                },
                style: {
                    cursor: "pointer",
                },
            };
        } else {
            return {};
        }
    }

    handleSerialNumberChange(evt) {
        this.setState({ serialNumber: evt.target.value });
    }

    render() {
        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 card-fluide without-side-margin">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="offset-lg-2 col-lg-8 offset-md-2 col-md-8 col-sm-12 col-12 without-side-padding">
                        <div className="row div-center">
                            <form
                                onSubmit={this.handleSearchClick.bind(this)}
                                className="col-lg-12 col-md-12 col-sm-12 col-12"
                            >
                                <CustomizedTextField
                                    className="textField col-lg-6 col-md-6 col-sm-6 col-7"
                                    onChange={this.handleSerialNumberChange.bind(this)}
                                    value={this.state.serialNumber}
                                    label="Numéro de série OEP"
                                />
                                <Fab
                                    variant="extended"
                                    type="submit"
                                    className="col-lg-3 col-md-4 col-sm-6 col-5"
                                    color="primary"
                                >
                                    <Icon>search</Icon>
                                    Rechercher
                                </Fab>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                        <TableWithoutPagination
                            data={this.props.searchHistory}
                            columns={this.state.columns}
                            minRows={5}
                            getTrProps={this.getTableTrProps.bind(this)}
                        />
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        searchHistory: state.searchHistory.searchHistory,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualSearchTab);
